var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M299.5 3.9H111.4c-18.2.1-32.9 14.8-33 33v438.2c0 18.2 14.8 32.9 32.9 32.9h330.4c18.2 0 32.9-14.8 33-32.9l-.9-325.5z",
    opacity: 1,
    "data-original": "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1565c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.7 512H111.4c-20.4 0-36.9-16.5-36.9-36.9V36.9C74.5 16.5 91 0 111.4 0H301l176.8 147.8.9 327.3c-.1 20.4-16.6 36.9-37 36.9zM111.4 7.9c-16 0-29 13-29 29v438.2c0 16 13 29 29 29h330.4c16 0 29-13 29-29l-.9-323.6L298.1 7.9z",
    fill: "#1565c0",
    opacity: 1,
    "data-original": "#1565c0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.5 3.9-.5 142.3s.5 3.4 3.5 3.4h171.3z",
    fill: "#1565c0",
    opacity: 1,
    "data-original": "#1565c0",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M47 246.9h332c7.5 0 13.6 6.1 13.6 13.6v148c0 7.5-6.1 13.6-13.6 13.6H47c-7.5 0-13.6-6.1-13.6-13.6v-148c0-7.6 6.1-13.6 13.6-13.6z",
    opacity: 1,
    "data-original": "#1565c0",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 358.7H66.5l-3.4 11.5h-22l26.2-69.7h23.5l26.2 69.7H94.4zm-4.5-15.1-7.7-25-7.6 25zM165.9 300.5h21.5V342c0 4-.6 7.9-1.9 11.7-1.2 3.6-3.3 6.9-6 9.6-2.4 2.5-5.4 4.5-8.6 5.8-4.9 1.7-10 2.4-15.1 2.3-3.7 0-7.4-.3-11.1-.7-3.5-.3-6.9-1.3-10.1-2.8-2.8-1.5-5.3-3.5-7.4-6-2.1-2.3-3.6-5-4.6-8-1.2-3.8-1.9-7.8-2-11.8v-41.5h21.5V343c0 3.8 1.1 6.8 3.2 8.9s5 3.2 8.8 3.2c3.7 0 6.6-1.1 8.7-3.2s3.2-5.1 3.2-9zM201.9 300.5h32c6.3 0 11.4.9 15.3 2.6 3.8 1.6 7.1 4.2 9.6 7.4 2.6 3.3 4.5 7.1 5.5 11.2 1.2 4.4 1.7 8.9 1.7 13.5 0 7.4-.9 13.2-2.6 17.3-1.6 3.9-4 7.4-7.1 10.3-2.7 2.6-6.1 4.5-9.7 5.5-4.2 1.2-8.5 1.8-12.8 1.9h-32zm21.6 15.8v38.1h5.3c4.5 0 7.7-.5 9.6-1.5 2.1-1.2 3.6-3 4.5-5.2 1.1-2.5 1.6-6.5 1.6-12.1 0-7.4-1.2-12.4-3.6-15.2-2.4-2.7-6.4-4.1-12-4.1zM278.2 300.5h21.6v69.7h-21.6zM312.6 335.4c0-11.4 3.2-20.2 9.5-26.6s15.2-9.5 26.5-9.5c11.6 0 20.5 3.1 26.8 9.3s9.4 15 9.4 26.2c0 8.1-1.4 14.8-4.1 20-2.7 5.1-6.8 9.4-11.9 12.2-5.2 2.9-11.6 4.4-19.4 4.4-7.9 0-14.4-1.3-19.5-3.8-5.3-2.6-9.6-6.7-12.5-11.9-3.2-5.4-4.8-12.1-4.8-20.3zm21.5.1c0 7 1.3 12.1 3.9 15.2 2.7 3.1 6.6 4.8 10.7 4.6 4.6 0 8.2-1.5 10.8-4.5 2.5-3 3.8-8.4 3.8-16.2 0-6.6-1.3-11.4-4-14.4s-6.3-4.5-10.8-4.5c-4-.2-7.9 1.5-10.5 4.6-2.6 3-3.9 8.1-3.9 15.2z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.14bb927806a0ed33f22ecac433140c9a.svg";
export { ForwardRef as ReactComponent };